import * as React from 'react';
import { useEffect, useRef } from 'react';
import DisplayQtyMinQtyMult from 'src/component/Product/DisplayQtyMinQtyMult';
import { useBOMStore } from 'src/hooks/bom';
import { system_notification } from 'src/store/slice/system';
import store from 'src/storeWire';
import { BomRemovePart } from 'src/reusable/bom'
import useTabDisplayStatus from "./hook";
import Common from "../../Common";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import useReduxState from "../../../../hooks/useReduxState";
import { useSelector } from "react-redux";
import $ from "jquery";
import "floating-scroll";
import stickyTableCommon from 'src/helper/stickyTableCommon';

const BomNoMatchTable = (props) => {
    const [{ bom_detail_by_bom_id_type }] = useBOMStore();
    const [displayStatus] = useTabDisplayStatus('NoMatch');
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const refLoadMore = useRef();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);

    useEffect(() => {
        if (refLoadMore.current !== undefined && refLoadMore.current && axios_indicator['BOM_TAB_API_CALL'] !== undefined) {
            /* Disabling for now
            refLoadMore.current.scrollIntoView({behavior: 'smooth', block: 'start'})*/
        }
        setTimeout(() => {
            $(".floating-table").floatingScroll("init");
        }, 2000)
    }, [axios_indicator]);
    const [__check] = useAxiosIndicatorCheck();

    /**
     * Ticket #  : 10890
     * Change #  : Common function called for sticky header
     * Change by : Pankaj
     * Date      : 29 Aug,2023
     */
    useEffect(() => {
        let callBackResult;
        if (bom_detail_by_bom_id_type && bom_detail_by_bom_id_type.NoMatch && Object.entries(bom_detail_by_bom_id_type.NoMatch.records).length > 0) {
            callBackResult = stickyTableCommon('bomnomatch-table', null)
        }
    }, [bom_detail_by_bom_id_type, __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status])
    return (
        <>
            <div className="tab-content p-0">
                <div id='sticky-table-wrapper'
                    className={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status ? "floating-table table-responsive loader-wrapper-outer minh350  mb-0" : "floating-table table-responsive  mb-0 sticky-table-wrapper"}>
                    {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL'], { overlay: true }).render}
                    <table id='bomnomatch-table' className="bs5 table table-bordered">
                        <thead style={{
                            display: displayStatus() ? '' : 'none'
                        }}>
                            <tr>
                                <th className="w-85"></th>

                                <th className="text-nowrap w200">Part Number</th>
                                <th className="text-nowrap w220">Manufacturer Part Number</th>
                                <th className="text-nowrap w150">Quantity</th>
                                <th className="text-nowrap w160">Price</th>
                                <th className="text-nowrap w200">Availability</th>
                                <th className="text-nowrap">manufacturer</th>
                                <th className="text-nowrap">Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayStatus() &&
                                Object.entries(bom_detail_by_bom_id_type.NoMatch.records).map((v) => (
                                    <tr className="align-top" key={v}>
                                        <td>
                                            <span className="index-count">{v[1].sequenceNumber}</span>
                                        </td>


                                        {v[1].isDeleted === false &&
                                            <td>
                                                <div className="d-flex w-100 justify-content-between align-items-center">
                                                    <div>
                                                        {v[1].partNumberRaw}
                                                    </div>
                                                    <BomRemovePart bomId={v[1].bomId} bomDetailId={v[1].bomDetailId} removeType={"noMatches"} removePartNumber={v[1].partNumberRaw} />
                                                </div>
                                            </td>
                                        }

                                        {v[1].isDeleted === true &&
                                            <td>
                                                Deleted: {v[1].manufacturerPartNumber}
                                            </td>
                                        }

                                        {v[1].isDeleted === false &&
                                            <>
                                                <td>
                                                    <p className="mb-3">No match found</p>
                                                    <a href={void (0)} className="d-block text-blue2"
                                                        onClick={() => {
                                                            store.dispatch(system_notification({
                                                                name: 'FindPartPopup',
                                                                data: {
                                                                    bomDetailId: v[1].bomDetailId,
                                                                    no_match: true,
                                                                    manufacturerPartNumber: v[1].manufacturerPartNumber,
                                                                    search_param: v[1].partNumberRaw,
                                                                    addFrom:"FindPart"
                                                                },
                                                            }));
                                                        }}>Find part</a>
                                                </td>


                                                <td>
                                                    <input type="text"
                                                        onChange={() => {
                                                        }}
                                                        value={v[1].quantity}
                                                        className="form-control form-control-sm" />
                                                    <div className="text-start small-text light light-text collapse_minmax text-nowrap">
                                                        <DisplayQtyMinQtyMult
                                                            single_product={v[1].product}
                                                        />
                                                    </div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>

                                            </>
                                        }
                                        {v[1].isDeleted === true &&
                                            <>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </>
                                        }
                                    </tr>
                                ))}

                        </tbody>
                    </table>
                </div>
            </div>
            {displayStatus() && Object.entries(bom_detail_by_bom_id_type.NoMatch.records).length < (bom_detail_by_bom_id_type.NoMatch.count + bom_detail_by_bom_id_type.NoMatch.deleted) &&
                <div className="pagination-row text-center"
                    style={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status ? { display: 'none' } : {}}>
                    <button ref={refLoadMore} onClick={() => {
                        SetTop(Common.loadMore(top, props))
                    }} className="bs5 m-t-30 m-b-30 btn btn-secondary w155">Load More
            </button>
                </div>
            }
            {!(displayStatus() && Object.entries(bom_detail_by_bom_id_type.NoMatch.records).length < bom_detail_by_bom_id_type.NoMatch.count) &&
                <div className="pagination-row text-center">
                </div>
            }
        </>
    );
}

export default BomNoMatchTable;